import React, {useState, useEffect} from 'react';
import {Form, InputGroup} from 'react-bootstrap';

const CheckboxItem = (props: any) => {
  const [checked, SetChecked] = useState(false);
  const [other, SetOther] = useState('');
  return (
    <>
      {props.type === 'label' ? (
        <Form.Check
          name={`survey-checkbox-question-${props.number}`}
          className="mb-2"
          type={props.question_type === 'single' ? 'radio' : 'checkbox'}
          id={`survey-checkbox-question-${props.number}-${props.id}`}
          label={props.value}
          onChange={(e) => {
            props.onChange(
              props.number,
              props.id,
              props.value,
              e.target.checked,
              props.question_type
            );
            SetChecked(e.target.checked);
          }}
        />
      ) : (
        <InputGroup className="mb-2">
          <Form.Check
            name={`survey-checkbox-question-${props.number}`}
            type={props.question_type === 'single' ? 'radio' : 'checkbox'}
            id={`survey-checkbox-question-${props.number}-${props.id}`}
            label={props.value}
            onChange={(e) => {
              props.onChange(
                props.number,
                props.id,
                `${props.value}:${other}`,
                e.target.checked,
                props.question_type
              );
              SetChecked(e.target.checked);
            }}
          />
          <Form.Control
            className="col-6 ml-2"
            id={`survey-textbox-${props.id}`}
            name="other"
            placeholder="Other"
            onChange={(e) => {
              SetOther(e.target.value);
              props.onChange(
                props.number,
                props.id,
                `${props.value}:${e.target.value}`,
                checked,
                props.question_type
              );
            }}
          />
        </InputGroup>
      )}
    </>
  );
};

export default function SurveyItem(props: any) {
  const updateState = (
    number: number,
    id: number,
    value: string,
    checked: boolean,
    type: string
  ) => {
    console.log(number);
    console.log(id);
    console.log(value);
    console.log(checked);
    console.log(type);
    props.onChange(number, id, value, checked, type);
  };

  return (
    <Form>
      <Form.Group
      className={props.show && props.show.show ? 'd-block' : 'd-none'}
      // controlId={`survey-checkbox-question${props.question_number}`}
      >
        <div className="mb-2">{props.question}</div>
        <div className="mb-2">{props.show && props.show.show}</div>
        <div
          key={`survey-checkbox-question-${props.question_number}`}
          className="mb-3"
        >
          {props.choice &&
            props.choice.map((e: any, i: number) => (
              <CheckboxItem
                key={`${props.question_number}-${i}`}
                id={i}
                number={props.question_number}
                question_type={props.question_type}
                value={e.value}
                type={e.type}
                onChange={updateState}
              ></CheckboxItem>
            ))}
        </div>
        <hr />
      </Form.Group>
    </Form>
  );
}
